import React from "react"
import ResponseError from "../utils/ResponseError"
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertIcon,
  AlertTitle,
  Flex,
  List,
  ListItem,
  Stack,
  Text
} from "@chakra-ui/react"
import { StatusCodes } from "http-status-codes"
import Settings from "../utils/CarrotConfig"

export type ErrorMessageProps = {
  message?: string
  error?: ResponseError
  errors?: Array<ResponseError>
  children?: React.ReactNode
}

export default function ErrorWrapper({
  message = null,
  error = null,
  errors = [],
  children
}: ErrorMessageProps): JSX.Element {
  if (error) {
    errors.push(error)
  }

  const cleanErrors = errors.filter(Boolean)

  if (cleanErrors.length === 0) {
    return <>{children}</>
  }

  if (cleanErrors.filter((error) => (error as ResponseError)?.statusCode === StatusCodes.UNAUTHORIZED).length > 0) {
    const currentUrl = encodeURIComponent(window.location.href)
    window.location.href = `${Settings.LOGIN_URL}?ReturnUrl=${currentUrl}`
    return null
  }

  return (
    <Alert status="error" width="100%">
      <Stack align="center" width="100%">
        <Flex grow={1}>
          <AlertIcon />
          <AlertTitle>{message ?? "Oops, something went wrong!"}</AlertTitle>
        </Flex>
        <Text>Please refresh the page and try again</Text>
        <Accordion allowToggle width="100%">
          <AccordionItem border="none">
            <AccordionButton>
              <Text flex="1" textAlign="center">
                See details
              </Text>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel padding={0}>
              <List>
                {cleanErrors.map((error, i) => (
                  <ListItem key={`error-${i}`} pb={4}>
                    {error?.message && <Text>{error.message}</Text>}
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                  </ListItem>
                ))}
              </List>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Stack>
    </Alert>
  )
}
